export enum TeamTypeLifecycleStepType {
	CreateProlongTeamTask,
	CreateCheckRetentionPeriodTask,
	SendProlongationReminder,
	CloseTeam,
	SendProlongationMail
}